"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationSerializer = void 0;
var ConfigurationSerializer = /** @class */ (function () {
    function ConfigurationSerializer() {
    }
    ConfigurationSerializer.prototype.serialize = function (data) {
        return {
            ga: data.ga ? this.serializeGoogleAnalytics(data.ga) : undefined,
            analytics: data.analytics ? this.serializeAnalyticsConfiguration(data.analytics) : undefined,
        };
    };
    ConfigurationSerializer.prototype.serializeGoogleAnalytics = function (googleAnalytics) {
        return {
            trackId: googleAnalytics.trackId,
        };
    };
    ConfigurationSerializer.prototype.serializeAnalyticsConfiguration = function (analyticsConfiguration) {
        return {
            dpAnalyticsEndpoint: analyticsConfiguration.dpAnalyticsEndpoint,
            dpAnalyticsKey: analyticsConfiguration.dpAnalyticsKey,
            avrMessage: analyticsConfiguration.avrMessage,
        };
    };
    return ConfigurationSerializer;
}());
exports.ConfigurationSerializer = ConfigurationSerializer;
